import React from 'react';
import debounce from 'lodash/debounce';
import styled from 'styled-components';

import { mq } from '@utils/responsive';
import Desktop from './desktop';
import Mobile from './mobile';

const Wrapper = styled.div`
  & > div:first-child {
    display: block;
  }

  & > div:last-child {
    display: none;
  }

  ${mq.gtsm`
    & > div:first-child {
      display: none;
    }

    & > div:last-child {
      display: block;
    }
  `}
`;

function SearchSortFilter(props) {
  const debouncedSearch = debounce(props.controller.search, 500);

  const handleFilter = (key, value) => {
    props.controller.filter(key, value);
  };

  const handleSearch = (evt) => {
    const { value } = evt.target;
    debouncedSearch(value);
  };

  const handleSort = (value) => {
    props.controller.sort(value);
  };

  return (
    <Wrapper>
      <div>
        <Mobile
          {...props}
          handleFilter={handleFilter}
          handleSearch={props.controller.search}
          handleSort={handleSort}
        />
      </div>
      <div>
        <Desktop
          {...props}
          handleFilter={handleFilter}
          handleSearch={handleSearch}
          handleSort={handleSort}
        />
      </div>
    </Wrapper>
  );
}

export default SearchSortFilter;
